"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEXP_SPECIAL_CHARACTERS = void 0;
exports.REGEXP_SPECIAL_CHARACTERS = /[\\^$.*+?()[\]{}|]/g;
//# sourceMappingURL=special-characters.regexp.js.map